"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_hook_form_1 = require("react-hook-form");
var recoil_1 = require("recoil");
var components_1 = require("@/components");
var Input_component_1 = require("@/components/common/Input/Input.component");
var Styled = __importStar(require("./ScheduleTemplate.styled"));
var store_1 = require("@/store");
var SessionTemplate_1 = require("../SessionTemplate");
var plus_20_svg_1 = __importDefault(require("@/assets/svg/plus-20.svg"));
var utils_1 = require("@/utils");
var hooks_1 = require("@/hooks");
var DEFAULT_SESSION = {
    startedAt: '',
    name: '',
    endedAt: '',
    contentsCreateRequests: [],
};
var DAUM_POSTCODE_SCRIPT = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
var DAUM_POSTCODE_API_URL = 'https://dapi.kakao.com/v2/local/search/address';
var ScheduleTemplate = function () {
    var _a = (0, react_hook_form_1.useFormContext)(), register = _a.register, control = _a.control, formState = _a.formState, getValues = _a.getValues, watch = _a.watch, setValue = _a.setValue;
    var generations = (0, recoil_1.useRecoilValue)(store_1.$generations);
    var _b = __read((0, recoil_1.useRecoilValue)(store_1.$profile), 1), position = _b[0];
    var teams = (0, recoil_1.useRecoilValue)(store_1.$teams);
    var locationType = watch('locationType');
    var scheduleType = watch('scheduleType');
    var _c = (0, react_hook_form_1.useFieldArray)({
        name: 'sessions',
        control: control,
    }), fields = _c.fields, append = _c.append, remove = _c.remove;
    (0, hooks_1.useScript)(DAUM_POSTCODE_SCRIPT);
    var generationOptions = (0, react_2.useMemo)(function () {
        return generations.map(function (_a) {
            var generationNumber = _a.generationNumber;
            return ({
                label: "".concat(generationNumber, "\uAE30"),
                value: generationNumber.toString(),
            });
        });
    }, [generations]);
    var defaultOption = generationOptions.find(function (option) { var _a; return option.value === ((_a = getValues('generationNumber')) === null || _a === void 0 ? void 0 : _a.toString()); });
    var generationPlatformOptions = teams.map(function (_a) {
        var name = _a.name;
        return ({
            value: name.toUpperCase(),
            label: name,
        });
    });
    var getTeamSelectOptions = function () {
        var myTeamOptionObject = generationPlatformOptions.find(function (_a) {
            var value = _a.value;
            return value === position;
        });
        return myTeamOptionObject ? [myTeamOptionObject] : generationPlatformOptions;
    };
    var teamSelectOptions = getTeamSelectOptions();
    var defaultPlatformOption = generationPlatformOptions.find(function (option) { return option.value === getValues('schedulePlatformType'); });
    var handleClickAddressSearch = function () {
        new window.daum.Postcode({
            oncomplete: function (data) {
                return __awaiter(this, void 0, void 0, function () {
                    var res, json, _a, address, longitude, latitude, buildingName, placeName;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, fetch("".concat(DAUM_POSTCODE_API_URL, "?query=").concat(data.address), {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "KakaoAK ".concat(process.env.KAKAO_KEY),
                                    },
                                })];
                            case 1:
                                res = _b.sent();
                                return [4 /*yield*/, res.json()];
                            case 2:
                                json = _b.sent();
                                _a = json.documents[0].road_address, address = _a.address_name, longitude = _a.x, latitude = _a.y, buildingName = _a.building_name;
                                placeName = buildingName || '';
                                setValue('locationInfo', {
                                    roadAddress: address,
                                    latitude: latitude,
                                    longitude: longitude,
                                    detailAddress: placeName,
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }).open();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Styled.ScheduleContent, { children: [(0, jsx_runtime_1.jsx)(Styled.Title, { children: "\uC2A4\uCF00\uC904 \uC815\uBCF4" }, void 0), (0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": Input_component_1.InputSize.md, label: "\uC2A4\uCF00\uC904 \uC81C\uBAA9", placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694", required: true }, register('name', { required: true })), void 0), (0, jsx_runtime_1.jsx)(components_1.SelectField, __assign({ label: "\uAE30\uC218", size: "md", options: generationOptions, defaultValue: defaultOption, required: true, isFullWidth: true }, register('generationNumber', { required: true })), void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(Styled.InputLabel, __assign({ htmlFor: "location" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "\uAD6C\uBD84" }, void 0), (0, jsx_runtime_1.jsx)(Styled.RequiredDot, {}, void 0)] }), void 0), (0, jsx_runtime_1.jsxs)(Styled.RadioButtonGroup, { children: [(0, jsx_runtime_1.jsx)(components_1.RadioButtonField, __assign({ label: "\uD50C\uB7AB\uD3FC", required: true, value: utils_1.ScheduleType.PLATFORM }, register('scheduleType', { required: true })), void 0), (0, jsx_runtime_1.jsx)(components_1.RadioButtonField, __assign({ label: "\uC804\uCCB4", required: true, value: utils_1.ScheduleType.ALL }, register('scheduleType', { required: true })), void 0)] }, void 0), scheduleType === utils_1.ScheduleType.PLATFORM && ((0, jsx_runtime_1.jsx)(components_1.SelectField, __assign({ size: "md", options: teamSelectOptions, defaultValue: defaultPlatformOption, required: true }, register('schedulePlatformType', {
                                required: scheduleType === utils_1.ScheduleType.PLATFORM,
                            })), void 0))] }, void 0), (0, jsx_runtime_1.jsx)(components_1.DatePickerField, __assign({ label: "\uC2A4\uCF00\uC904 \uC77C\uC2DC", "$size": "md", placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694", required: true, defaultDate: getValues('date') }, register('date', { required: true })), void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(Styled.InputLabel, __assign({ htmlFor: "location" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "\uC7A5\uC18C" }, void 0), (0, jsx_runtime_1.jsx)(Styled.RequiredDot, {}, void 0)] }), void 0), (0, jsx_runtime_1.jsxs)(Styled.RadioButtonGroup, { children: [(0, jsx_runtime_1.jsx)(components_1.RadioButtonField, __assign({ label: "\uC624\uD504\uB77C\uC778", required: true, value: utils_1.LocationType.OFFLINE }, register('locationType', { required: true })), void 0), (0, jsx_runtime_1.jsx)(components_1.RadioButtonField, __assign({ label: "\uC628\uB77C\uC778", required: true, value: utils_1.LocationType.ONLINE }, register('locationType', { required: true })), void 0)] }, void 0), locationType === utils_1.LocationType.OFFLINE && ((0, jsx_runtime_1.jsxs)(Styled.LocationWrapper, { children: [(0, jsx_runtime_1.jsxs)(Styled.InputWithButton, { children: [(0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": "md", placeholder: "\uC8FC\uC18C", disabled: false }, register('locationInfo.roadAddress', {
                                                required: locationType === utils_1.LocationType.OFFLINE,
                                            })), void 0), (0, jsx_runtime_1.jsx)(components_1.Button, __assign({ shape: "primaryLine", "$size": "md", onClick: handleClickAddressSearch }, { children: "\uC8FC\uC18C \uAC80\uC0C9" }), void 0)] }, void 0), (0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": "md", placeholder: "\uC0C1\uC138 \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694 (ex. \uB3D9, \uD638, \uCE35 \uB4F1)" }, register('locationInfo.detailAddress')), void 0)] }, void 0))] }, void 0), (0, jsx_runtime_1.jsx)(components_1.Textarea, __assign({ label: "\uACF5\uC9C0" }, register('notice')), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.SessionContent, { children: [(0, jsx_runtime_1.jsx)(Styled.Title, { children: "\uC138\uC158 \uC815\uBCF4" }, void 0), fields.map(function (field, index) {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)(SessionTemplate_1.SessionTemplate, __assign({ index: index }, field, { onRemove: remove, errors: (_a = formState.errors.sessions) === null || _a === void 0 ? void 0 : _a[index] }), field.id));
                    }), (0, jsx_runtime_1.jsxs)(Styled.AddButton, __assign({ type: "button", onClick: function () { return append(DEFAULT_SESSION); } }, { children: [(0, jsx_runtime_1.jsx)(plus_20_svg_1.default, {}, void 0), "\uC138\uC158 \uCD94\uAC00"] }), void 0)] }, void 0)] }, void 0));
};
exports.default = ScheduleTemplate;
